import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "react-redux";
import {getCatalog, getPunkts, setCabinetActiveTab, setSelectedAction} from "@cabinet-packages/redux";
import {useHistory, useLocation} from "react-router";
import {Accordion, AccordionDetails, AccordionSummary, Button, Typography} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {AddRemoveIconButtons, Loading} from "@cabinet-packages/components";
import {Helmet} from "react-helmet";

const useStyles = makeStyles((theme)=> ({
    root: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    scrollWrapper: {
        position: 'relative',
        width: '100%',
        flex: '1 1 auto',
        minHeight: 0,
    },
    scrollContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
    },
    rootWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',

        '@media (max-width: 1040px)': {
            flexDirection: 'column',
        }
    },
    orderButtonContainer: {
        flex: '0 0 auto',
        padding: '5px 0',
        background: 'white',

        '@media (max-width: 1040px)': {
            padding: '5px',
        },
    },
    orderButton: {
        width: '100%',
    },
    expansionPanel: {
        padding: '8px',
    },
    accordionHeading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightBold,
    },
    details: {
        padding: '8px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        '@media (max-width: 1040px)': {
            flexDirection: 'column',
        },
    },
    detailsImgWrapper: {
        padding: '8px',

        '@media (max-width: 1040px)': {
            padding: '0px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
        }
    },
    detailsImg: {
        border: '1px solid rgba(0,0,0,0.1)',
        maxWidth: '300px',
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        backgroundSize: 'contain',
        '@media(max-width: 900px)': {
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            position: 'relative',
            minWidth: '100%',
            maxWidth: '100%',
            backgroundSize: 'contain',
        }
    },
    detailsText: {
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        textAlign: 'right',

        '@media (max-width: 1040px)': {
            display: 'none',
        },
    },
    detailsTextNearImg: {
        padding: '8px',
        display: 'none',
        flexDirection: 'column',
        justifyContent: 'space-between',

        '@media (max-width: 1040px)': {
            display: 'flex',
        },
    },
    detailsTextPriceContainer: {
        fontWeight: 600,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        paddingTop: '8px',
    },
    detailsTextPrice: {
        alignSelf: 'center',
        color: theme.palette.error.light,
        paddingRight: '8px',
    },
}))

const ActionsDetails = ({isComponentInShop}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { selectedActionForView, catalog, actions, complexResearch, takeId, complexId } = useSelector(state => state.assaysCatalog);
    const { orderingList, amountOfItems } = useSelector(state => state.orderAssays);
    const [sendTag, setSendTag] = useState(false);
    const { punkts } = useSelector(store => store.collectionPoints);
    const location = useLocation();
    const history = useHistory();
    const locationActionID = [...location.pathname.split('/')].pop();
    const {imgUrl} = useSelector(store => store.theme);
    const hrefLocation = window.location.href;
    const productList = catalog && selectedActionForView && catalog.filter(assay =>selectedActionForView.idGrTest.includes(assay.id))

    const isIncludedInOrderingList = selectedActionForView && orderingList.find(assay => assay.id === selectedActionForView.id && assay.type === selectedActionForView.type);
    const actionInOrderList = orderingList.filter(actionID => actions.find(item => item.id === actionID.id && actionID.type === item.type));

    useEffect(() => {
        dispatch(setCabinetActiveTab("/patient-actions"))
    }, [])

    const handleTransitionToOrderManager = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if(isComponentInShop) history.push('/shop-order-manager')
        else {
            history.push('/order-manager')
        }
    };

    useEffect(() => {
        dispatch(getPunkts());

        if ((!selectedActionForView || +selectedActionForView?.id !== +locationActionID) && locationActionID && actions) {
            dispatch(setSelectedAction(actions.find(action => +action.id === +locationActionID)))
        }
    }, [dispatch, catalog, punkts, locationActionID, actions, selectedActionForView]);

    useEffect(() => {
        if (!catalog && takeId && complexId) dispatch(getCatalog());
    }, [catalog, dispatch, takeId, complexId]);

    return (
        <div className={classes.root} key={locationActionID}>
            {!selectedActionForView
                ? <Loading/>
                : <div className={classes.scrollWrapper}><div className={classes.scrollContainer}><div className={classes.rootWrapper}>
                    <div className={classes.details}>
                        <div className={classes.detailsImgWrapper}>
                            <img
                                className={classes.detailsImg}
                                src={!!selectedActionForView.fileName
                                        ? `https://biokurs-billing.medclinic.in.ua//modules/bi_action/files/${selectedActionForView.fileName}`
                                        : imgUrl
                                }
                                alt="Action img."
                                 />
                        </div>
                        <div className={classes.detailsTextNearImg}>
                            {selectedActionForView.note && <div className="holovna" dangerouslySetInnerHTML={{__html: selectedActionForView.note}}/>}
                            <div className={classes.detailsTextPriceContainer}>
                                <p className={classes.detailsTextPrice}>{selectedActionForView.price} грн</p>
                                <div className={classes.addRemoveButton}>
                                    {selectedActionForView.discount === 0 && <AddRemoveIconButtons
                                        item={selectedActionForView}
                                        isIncludedInOrderingList={isIncludedInOrderingList}
                                        actionInOrderList={actionInOrderList}
                                        assayInfo={true}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.expansionPanel}>
                        <div className={classes.detailsText}>
                            {selectedActionForView.note && <div className="holovna" dangerouslySetInnerHTML={{__html: selectedActionForView.note}}/>}
                            <div className={classes.detailsTextPriceContainer}>
                                <p className={classes.detailsTextPrice}>{selectedActionForView.price} грн</p>
                                <div className={classes.addRemoveButton}>
                                    {selectedActionForView.discount === 0 &&<AddRemoveIconButtons
                                        item={selectedActionForView}
                                        isIncludedInOrderingList={isIncludedInOrderingList}
                                        actionInOrderList={actionInOrderList}
                                        assayInfo={true}
                                    />}
                                </div>
                            </div>
                        </div>
                        {productList && <Accordion
                            defaultExpanded={!productList.find(i=>i?.opt?.includes('rolled'))}
                            TransitionProps={{timeout: 0}}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                <Typography className={classes.accordionHeading}>Акційні дослідження:</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div>
                                    {productList.map(product =><div key={product.name}>
                                        <a href={"/assay-info/"+product.id}>{product.name}</a>
                                        {product.testNamesArr.length > 0 && product.testNamesArr.map(testName =>
                                                <p key={testName} style={{color: 'grey', marginLeft: '8px', fontSize: '12px'}}>
                                                {testName}
                                            </p>)}
                                    </div>)}
                                </div>
                            </AccordionDetails>
                        </Accordion>}
                        <Accordion TransitionProps={{timeout: 0}}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                <Typography className={classes.accordionHeading}>Адреси відділень, у яких діє акційна пропозиція:</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.details}>
                                <div>
                                    {punkts && selectedActionForView.idPunkts
                                        .map(idpunkt => punkts.find(punkt => +punkt.idPunkt === +idpunkt))
                                            .filter(item => item)
                                            .sort((a,b) => a.address.localeCompare(b.address))
                                            .map((punkt, idx) => (
                                                    <p key={punkt.idPunkt}>
                                                        {punkt.address}
                                                    </p>
                                            ))}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
            </div></div></div>}
            <div className={classes.orderButtonContainer}>
                <Button
                    className={classes.orderButton}
                    variant="outlined"
                    color="primary"
                    disabled={amountOfItems < 1}
                    onClick={handleTransitionToOrderManager}>
                    Перейти до замовлення
                </Button>
            </div>
            {selectedActionForView && selectedActionForView.name && <Helmet>
                <meta name="og:description" content={selectedActionForView.note}/>
                <meta property="og:url" content={hrefLocation}/>
                <meta name="og:image" content={'imgUrl'}/>
                <meta property="og:type" content="article" />
                <meta property="og:title" content={selectedActionForView.name ? selectedActionForView.name : selectedActionForView.testNames.split(',')[0].split('\\\\').join('')} />
            </Helmet>}
        </div>
    );
};

export default ActionsDetails;
